// The minimum soil temperatures for planting common crops are the following:

// spring wheat – 37°F (3°C);
// soybeans – 59°F (15°C);
// spring canola and sugar beat – 50°F (10°C);
// sunflower and millet – 60°F (16°C);
// dry beans are the most demanding, requiring 70°F (21°C) for their successful germination and rooting.
// The optimal soil temperature for growing vegetables varies from 65 to 75°F (18-24°C). For example:

// tomatoes and cucumbers – 60°F (16°C);
// sweet corn – 65°F (18°C);
// watermelons, peppers, and okra are the last ones to sow at 70°F (21°C).

const menu = [
  {
    name: "Spring Wheat",
    temperature: "276",
  },
  {
    name: "Spring barley",
    temperature: "278",
  },
  {
    name: "Rye",
    temperature: "278",
  },
  {
    name: "Oats",
    temperature: "279",
  },
  {
    name: "Alfalfa",
    temperature: "280",
  },
  {
    name: "Spring Canola",
    temperature: "283",
  },
  {
    name: "Sugarbeet",
    temperature: "283",
  },
  {
    name: "Field corn",
    temperature: "286",
  },
  {
    name: "Soybean",
    temperature: "288",
  },
  {
    name: "Sunflower",
    temperature: "289",
  },
  {
    name: "Millet",
    temperature: "289",
  },
  {
    name: "Sorghum",
    temperature: "291",
  },
  {
    name: "Dry Bean",
    temperature: "294",
  },
  {
    name: "Spinach",
    temperature: "276",
  },
  {
    name: "Radish",
    temperature: "278",
  },
  {
    name: "Lettuce",
    temperature: "278",
  },
  {
    name: "Onion",
    temperature: "278",
  },
  {
    name: "Pea",
    temperature: "279",
  },
  {
    name: "Potato",
    temperature: "280",
  },
  {
    name: "Cabbage",
    temperature: "280",
  },
  {
    name: "Carrot",
    temperature: "281",
  },
  {
    name: "Sweet Corn",
    temperature: "286",
  },
  {
    name: "Pepper",
    temperature: "287",
  },
  {
    name: "Snap Beans ",
    temperature: "287",
  },
  {
    name: "Tomato",
    temperature: "287",
  },
  {
    name: "Cucumber",
    temperature: "288",
  },
  {
    name: "Pumpkin",
    temperature: "289",
  },
];

export default menu;

//temperature are in kelvin

// In farenheit this is minimum soil temperature
